// removed by extract-text-webpack-plugin
module.exports = {"price-container":"Price__price-container___1fsLu","col":"Price__col___26wo9","no-error":"Price__no-error___3bz-u","has-error":"Price__has-error___2KGrx","error":"Price__error___widUo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Price/Price.css
// module id = 706
// module chunks = 0